import {
  MORE_COLOURS,
  MORE_COLOURS_FACET
} from "../../../state/modules/search/constants";

export const getBadgeText = ({ type, formatTranslation }) => {
  const label =
    type === MORE_COLOURS || type === MORE_COLOURS_FACET
      ? formatTranslation("plp_web_product_tile_badge_more_colors")
      : formatTranslation("plp_web_product_tile_badge_mix_match");

  return label;
};
